import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'src/root/store';

import type { NormalizedOrgProfile } from '../types';

const moduleSel = (state: RootState) => state.unit;

export const unitInfoSel = createSelector(
  moduleSel,
  state => state.unitInfo as NormalizedOrgProfile,
);

/**
 * This will be used to disable many actions from the UI like: viewing profiles from the roster items, nav items,
 * and some buttons in the Roster tab. See SBL-5832.
 */
export const isInactiveUnitSel = createSelector(unitInfoSel, unitInfo => {
  const isValid = unitInfo !== undefined;
  if (!isValid) return false;

  return unitInfo.charter?.isActive === false; // strict equal to avoid false positives
});
